export enum ErrorInitializeEnum {
  ERROR_LOAD_CATALOG_LIST = 'ERROR_LOAD_CATALOG_LIST',
  ERROR_LOAD_PRODUCT_MAP = 'ERROR_LOAD_PRODUCT_MAP',
  ERROR_LOAD_SELECTED_CITY = 'ERROR_LOAD_SELECTED_CITY',
}
